module.exports = __webpack_public_path__ + "img/convenience.b30330ee.png";